import React from "react";

export const Version = () => <span>{process.env.REACT_APP_GIT_HASH}</span>;
